import { IconElementsProps } from "../icon-elements-props.type";
import { iconSizes } from "../icon-sizes";

export function Stats(props: IconElementsProps) {
  const {
    className,
    primaryColor = "#00083C",
    width,
    height,
    size = "S",
  } = props;

  return (
    <svg
      className={className}
      style={{
        minWidth: width || iconSizes[size],
        minHeight: height || iconSizes[size],
      }}
      width={width || iconSizes[size]}
      height={height || iconSizes[size]}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_437_29599)">
        <g clipPath="url(#clip1_437_29599)">
          <g clipPath="url(#clip2_437_29599)">
            <path
              d="M15.7501 2.00003H20.3041L20.4041 2.01403L20.5031 2.04203L20.5631 2.06803C20.6431 2.10203 20.7161 2.15303 20.7821 2.21803L20.8221 2.26203L20.8661 2.31903L20.9201 2.40903L20.9591 2.49903L20.9781 2.56303L20.9921 2.62703L21.0011 2.72203V7.25403C21.001 7.44405 20.9288 7.62697 20.7991 7.76582C20.6694 7.90467 20.4918 7.9891 20.3022 8.00206C20.1126 8.01501 19.9252 7.95552 19.7778 7.8356C19.6304 7.71568 19.534 7.54428 19.5081 7.35603L19.5011 7.25403V4.55903L13.0611 10.999C12.9341 11.126 12.7657 11.2033 12.5866 11.2167C12.4075 11.2301 12.2295 11.1787 12.0851 11.072L12.0011 11L8.97106 8.09003L3.28106 13.779C3.14723 13.9132 2.96757 13.9918 2.77818 13.9989C2.5888 14.006 2.40374 13.9412 2.26022 13.8174C2.11669 13.6937 2.02534 13.5201 2.00454 13.3318C1.98373 13.1434 2.03501 12.9541 2.14806 12.802L2.22106 12.718L8.44106 6.49803C8.56817 6.37116 8.73659 6.29412 8.9157 6.28091C9.0948 6.26769 9.27271 6.31919 9.41706 6.42603L9.50106 6.49803L12.5311 9.40803L18.4391 3.50003H15.7491C15.568 3.49978 15.3931 3.43404 15.2568 3.31494C15.1204 3.19583 15.0317 3.03141 15.0071 2.85203L15.0001 2.75003C15.0001 2.56879 15.0657 2.39369 15.1848 2.2571C15.304 2.12051 15.4685 2.03168 15.6481 2.00703L15.7511 2.00003H15.7501ZM2.75106 17C2.94997 17 3.14074 17.079 3.28139 17.2197C3.42204 17.3604 3.50106 17.5511 3.50106 17.75V21.25C3.50106 21.4489 3.42204 21.6397 3.28139 21.7804C3.14074 21.921 2.94997 22 2.75106 22C2.55215 22 2.36138 21.921 2.22073 21.7804C2.08008 21.6397 2.00106 21.4489 2.00106 21.25V17.75C2.00106 17.5511 2.08008 17.3604 2.22073 17.2197C2.36138 17.079 2.55215 17 2.75106 17ZM8.50106 13.75C8.50106 13.5511 8.42204 13.3604 8.28139 13.2197C8.14074 13.079 7.94997 13 7.75106 13C7.55215 13 7.36138 13.079 7.22073 13.2197C7.08008 13.3604 7.00106 13.5511 7.00106 13.75V21.25C7.00106 21.4489 7.08008 21.6397 7.22073 21.7804C7.36138 21.921 7.55215 22 7.75106 22C7.94997 22 8.14074 21.921 8.28139 21.7804C8.42204 21.6397 8.50106 21.4489 8.50106 21.25V13.75ZM12.7511 15C12.95 15 13.1407 15.079 13.2814 15.2197C13.422 15.3604 13.5011 15.5511 13.5011 15.75V21.25C13.5011 21.4489 13.422 21.6397 13.2814 21.7804C13.1407 21.921 12.95 22 12.7511 22C12.5521 22 12.3614 21.921 12.2207 21.7804C12.0801 21.6397 12.0011 21.4489 12.0011 21.25V15.75C12.0011 15.5511 12.0801 15.3604 12.2207 15.2197C12.3614 15.079 12.5521 15 12.7511 15ZM18.5011 10.75C18.5011 10.5511 18.422 10.3604 18.2814 10.2197C18.1407 10.079 17.95 10 17.7511 10C17.5521 10 17.3614 10.079 17.2207 10.2197C17.0801 10.3604 17.0011 10.5511 17.0011 10.75V21.25C17.0011 21.4489 17.0801 21.6397 17.2207 21.7804C17.3614 21.921 17.5521 22 17.7511 22C17.95 22 18.1407 21.921 18.2814 21.7804C18.422 21.6397 18.5011 21.4489 18.5011 21.25V10.75Z"
              fill={primaryColor}
            />
          </g>
        </g>
      </g>
      <defs>
        <clipPath id="clip0_437_29599">
          <rect
            width={width || iconSizes[size]}
            height={width || iconSizes[size]}
            fill="white"
          />
        </clipPath>
        <clipPath id="clip1_437_29599">
          <rect
            width={width || iconSizes[size]}
            height={width || iconSizes[size]}
            fill="white"
            transform="translate(0 0.171906)"
          />
        </clipPath>
        <clipPath id="clip2_437_29599">
          <rect
            width={width || iconSizes[size]}
            height={width || iconSizes[size]}
            fill="white"
            transform="translate(0 0.171661)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
